module.exports = __webpack_public_path__ + "static/sav.banner-mosaic-outros-componentes-c3d185590272b3004649804f3ec08f57.jpg";